export default values => ({
  counselorsIds: values.length ? values.map(value => value.id) : []
});
